/**
 * Translations for Pivot Performance
 * Supported: English, Spanish, French, German, Hindi, Arabic, Chinese, Portuguese, Korean, Japanese, Tagalog
 */

const translations = {
  en: {
    // App
    app_name: "Pivot Performance",
    beta_banner: "BETA MODE — All Features Unlocked",
    beta_spots: "spots remaining",
    free_trial: "16 days free trial",
    
    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    full_name: "Full Name",
    welcome_back: "Welcome Back",
    join_beta: "Create Account",
    start_training: "Start Training",
    dont_have_account: "Don't have an account?",
    already_have_account: "Already have an account?",
    sign_up: "Sign Up",
    sign_in: "Sign In",
    
    // Landing
    build_your: "Build Your",
    engine: "Engine",
    tagline: "Generational summer. Transform your game with conditioning, vertical training, and AI coaching.",
    engine_monitor: "Engine Monitor",
    engine_desc: "17-fives, suicides, full-court drills",
    vertical_tracker: "Vertical Tracker", 
    vertical_desc: "Track inches gained with vertical explosion.",
    ai_coaching: "AI Coaching",
    ai_desc: "Personalized feedback",
    break_the_cycle: "Break the Cycle",
    week_program: "Week Program",
    
    // Terms
    terms: "Terms and Conditions",
    accept_terms: "I accept the terms and conditions",
    health_warning: "Consult a physician before starting.",
    read_terms: "Read Terms",
    
    // Nav
    dashboard: "Dashboard",
    schedule: "Schedule",
    sessions: "Sessions",
    badges: "Badges",
    leaderboard: "Leaderboard",
    program: "Program",
    vertical: "Vertical",
    bodyweight: "Bodyweight",
    progress: "Progress",
    library: "Library",
    coach: "AI Coach",
    wearables: "Wearables",
    ecosystem: "Ecosystem",
    community: "Community",
    teams: "Teams",
    recovery: "Recovery",
    admin: "Admin",
    subscription: "Subscription",
    share: "Share",
    analytics: "Analytics",
    profile: "Profile",
    share: "Share",
    analytics: "Analytics",
    
    // Dashboard
    total_workouts: "Total Workouts",
    this_week: "This Week",
    vertical_gained: "Vertical Gained",
    current_vertical: "Current Vertical",
    quick_start: "Quick Start",
    ready_train: "Ready to Train?",
    your_progress: "Your Progress",
    recent_activity: "Recent Activity",
    todays_workout: "Today's Workout",
    
    // Grind
    week: "Week",
    day: "Day",
    phase: "Phase",
    complete: "Complete",
    active: "Active",
    locked: "Locked",
    unlocked: "Unlocked",
    beast_mode: "Beast Mode",
    current_streak: "Current Streak",
    days_completed: "Days Completed",
    total_days: "Total Days",
    start_workout: "Start Workout",
    mark_complete: "Mark Complete",
    rest_day: "Rest Day",
    
    // Leaderboard
    your_rank: "Your Ranking",
    points: "Points",
    streak: "Streak",
    global_rankings: "Global Rankings",
    top_athletes: "Top Athletes",
    
    // Subscription
    choose_level: "Choose Your Level",
    basic: "Basic",
    pro: "Pro", 
    elite: "Elite",
    per_month: "/month",
    popular: "Most Popular",
    subscribe_now: "Subscribe Now",
    
    // Offline
    offline: "You're offline",
    sync_ready: "items ready to sync",
    sync_now: "Sync Now",
    
    // Exercises
    push_ups: "Push-Ups",
    air_squats: "Air Squats",
    jump_rope: "Jump Rope",
    circuit: "Circuit",
    reps: "Reps",
    sets: "Sets",
    duration: "Duration",
    minutes: "minutes",
    seconds: "seconds",
    
    // Vertical Tracker
    log_jump: "Log Jump",
    jump_height: "Jump Height",
    inches: "inches",
    personal_best: "Personal Best",
    average_jump: "Average Jump",
    total_jumps: "Total Jumps",
    
    // Progress Photos
    upload_photo: "Upload Photo",
    compare: "Compare",
    timeline: "Timeline",
    gallery: "Gallery",
    front_pose: "Front Pose",
    side_pose: "Side Pose",
    back_pose: "Back Pose",
    
    // AI Coach
    ask_coach: "Ask the Coach",
    type_question: "Type your question...",
    send: "Send",
    thinking: "Thinking...",
    select_model: "Select AI Model",
    
    // Settings
    settings: "Settings",
    language: "Language",
    notifications: "Notifications",
    dark_mode: "Dark Mode",
    sound_effects: "Sound Effects",
    
    // Misc
    coming_soon: "Coming Soon",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    reset: "Reset",
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    close: "Close",
    next: "Next",
    previous: "Previous",
    view_all: "View All",
    see_more: "See More",
    error: "Error",
    success: "Success",
    warning: "Warning",
    no_data: "No data available",
  },
  
  es: {
    app_name: "Pivot Performance",
    beta_banner: "MODO BETA — Todas las Funciones Desbloqueadas",
    beta_spots: "lugares disponibles",
    free_trial: "16 días gratis",
    login: "Iniciar Sesión",
    register: "Registrarse",
    logout: "Cerrar Sesión",
    email: "Correo Electrónico",
    password: "Contraseña",
    full_name: "Nombre Completo",
    welcome_back: "Bienvenido de Nuevo",
    join_beta: "Crear Cuenta",
    start_training: "Comenzar Entrenamiento",
    dont_have_account: "¿No tienes cuenta?",
    already_have_account: "¿Ya tienes cuenta?",
    sign_up: "Registrarse",
    sign_in: "Ingresar",
    build_your: "Construye Tu",
    engine: "Motor",
    tagline: "Verano generacional. Transforma tu juego con acondicionamiento, entrenamiento vertical y coaching IA.",
    engine_monitor: "Monitor de Motor",
    engine_desc: "17-fives, suicidios, ejercicios de cancha completa",
    vertical_tracker: "Rastreador Vertical",
    vertical_desc: "Rastrea las pulgadas ganadas con explosión vertical.",
    ai_coaching: "Coaching IA",
    ai_desc: "Retroalimentación personalizada",
    break_the_cycle: "Rompe el Ciclo",
    week_program: "Programa Semanal",
    terms: "Términos y Condiciones",
    accept_terms: "Acepto los términos y condiciones",
    health_warning: "Consulta a un médico antes de comenzar.",
    read_terms: "Leer Términos",
    dashboard: "Panel",
    schedule: "Horario",
    sessions: "Sesiones",
    badges: "Insignias",
    leaderboard: "Clasificación",
    program: "Programa",
    vertical: "Vertical",
    bodyweight: "Peso Corporal",
    progress: "Progreso",
    library: "Biblioteca",
    coach: "Coach IA",
    wearables: "Wearables",
    ecosystem: "Ecosistema",
    community: "Comunidad",
    subscription: "Suscripción",
    profile: "Perfil",
    share: "Compartir",
    total_workouts: "Total Entrenamientos",
    this_week: "Esta Semana",
    vertical_gained: "Vertical Ganado",
    current_vertical: "Vertical Actual",
    quick_start: "Inicio Rápido",
    ready_train: "¿Listo para Entrenar?",
    your_progress: "Tu Progreso",
    recent_activity: "Actividad Reciente",
    todays_workout: "Entrenamiento de Hoy",
    week: "Semana",
    day: "Día",
    phase: "Fase",
    complete: "Completar",
    active: "Activo",
    locked: "Bloqueado",
    unlocked: "Desbloqueado",
    beast_mode: "Modo Bestia",
    current_streak: "Racha Actual",
    days_completed: "Días Completados",
    total_days: "Total Días",
    start_workout: "Iniciar Entrenamiento",
    mark_complete: "Marcar Completo",
    rest_day: "Día de Descanso",
    your_rank: "Tu Clasificación",
    points: "Puntos",
    streak: "Racha",
    global_rankings: "Rankings Globales",
    top_athletes: "Mejores Atletas",
    choose_level: "Elige Tu Nivel",
    basic: "Básico",
    pro: "Pro",
    elite: "Élite",
    per_month: "/mes",
    popular: "Más Popular",
    subscribe_now: "Suscribirse Ahora",
    offline: "Sin Conexión",
    sync_ready: "elementos listos para sincronizar",
    sync_now: "Sincronizar Ahora",
    push_ups: "Flexiones",
    air_squats: "Sentadillas",
    jump_rope: "Saltar la Cuerda",
    circuit: "Circuito",
    reps: "Reps",
    sets: "Series",
    duration: "Duración",
    minutes: "minutos",
    seconds: "segundos",
    log_jump: "Registrar Salto",
    jump_height: "Altura del Salto",
    inches: "pulgadas",
    personal_best: "Mejor Personal",
    average_jump: "Salto Promedio",
    total_jumps: "Total Saltos",
    upload_photo: "Subir Foto",
    compare: "Comparar",
    timeline: "Línea de Tiempo",
    gallery: "Galería",
    front_pose: "Pose Frontal",
    side_pose: "Pose Lateral",
    back_pose: "Pose Trasera",
    ask_coach: "Preguntar al Coach",
    type_question: "Escribe tu pregunta...",
    send: "Enviar",
    thinking: "Pensando...",
    select_model: "Seleccionar Modelo IA",
    settings: "Configuración",
    language: "Idioma",
    notifications: "Notificaciones",
    dark_mode: "Modo Oscuro",
    sound_effects: "Efectos de Sonido",
    coming_soon: "Próximamente",
    loading: "Cargando...",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    reset: "Reiniciar",
    undo: "Deshacer",
    redo: "Rehacer",
    confirm: "Confirmar",
    close: "Cerrar",
    next: "Siguiente",
    previous: "Anterior",
    view_all: "Ver Todo",
    see_more: "Ver Más",
    error: "Error",
    success: "Éxito",
    warning: "Advertencia",
    no_data: "Sin datos disponibles",
  },
  
  fr: {
    app_name: "Pivot Performance",
    beta_banner: "MODE BÊTA — Toutes les Fonctions Débloquées",
    beta_spots: "places restantes",
    free_trial: "16 jours gratuits",
    login: "Connexion",
    register: "S'inscrire",
    logout: "Déconnexion",
    email: "E-mail",
    password: "Mot de Passe",
    full_name: "Nom Complet",
    welcome_back: "Bon Retour",
    join_beta: "Créer un Compte",
    start_training: "Commencer l'Entraînement",
    dont_have_account: "Pas de compte?",
    already_have_account: "Déjà un compte?",
    sign_up: "S'inscrire",
    sign_in: "Se Connecter",
    build_your: "Construis Ton",
    engine: "Moteur",
    tagline: "Été générationnel. Transforme ton jeu avec le conditionnement, l'entraînement vertical et le coaching IA.",
    engine_monitor: "Moniteur Moteur",
    engine_desc: "17-fives, suicides, exercices sur terrain complet",
    vertical_tracker: "Suivi Vertical",
    vertical_desc: "Suivez les pouces gagnés avec l'explosion verticale.",
    ai_coaching: "Coaching IA",
    ai_desc: "Retour personnalisé",
    break_the_cycle: "Briser le Cycle",
    week_program: "Programme Hebdomadaire",
    terms: "Conditions Générales",
    accept_terms: "J'accepte les conditions générales",
    health_warning: "Consultez un médecin avant de commencer.",
    read_terms: "Lire les Conditions",
    dashboard: "Tableau de Bord",
    schedule: "Planning",
    sessions: "Séances",
    badges: "Badges",
    leaderboard: "Classement",
    program: "Programme",
    vertical: "Vertical",
    bodyweight: "Poids du Corps",
    progress: "Progrès",
    library: "Bibliothèque",
    coach: "Coach IA",
    wearables: "Wearables",
    ecosystem: "Écosystème",
    community: "Communauté",
    subscription: "Abonnement",
    profile: "Profil",
    share: "Partager",
    total_workouts: "Total Entraînements",
    this_week: "Cette Semaine",
    vertical_gained: "Vertical Gagné",
    current_vertical: "Vertical Actuel",
    quick_start: "Démarrage Rapide",
    ready_train: "Prêt à T'entraîner?",
    your_progress: "Ton Progrès",
    recent_activity: "Activité Récente",
    todays_workout: "Entraînement du Jour",
    week: "Semaine",
    day: "Jour",
    phase: "Phase",
    complete: "Terminer",
    active: "Actif",
    locked: "Verrouillé",
    unlocked: "Déverrouillé",
    beast_mode: "Mode Bête",
    current_streak: "Série Actuelle",
    days_completed: "Jours Complétés",
    total_days: "Total Jours",
    start_workout: "Démarrer l'Entraînement",
    mark_complete: "Marquer Terminé",
    rest_day: "Jour de Repos",
    your_rank: "Ton Classement",
    points: "Points",
    streak: "Série",
    global_rankings: "Classements Mondiaux",
    top_athletes: "Meilleurs Athlètes",
    choose_level: "Choisis Ton Niveau",
    basic: "Basique",
    pro: "Pro",
    elite: "Élite",
    per_month: "/mois",
    popular: "Plus Populaire",
    subscribe_now: "S'abonner Maintenant",
    offline: "Hors Ligne",
    sync_ready: "éléments prêts à synchroniser",
    sync_now: "Synchroniser",
    push_ups: "Pompes",
    air_squats: "Squats",
    jump_rope: "Corde à Sauter",
    circuit: "Circuit",
    reps: "Reps",
    sets: "Séries",
    duration: "Durée",
    minutes: "minutes",
    seconds: "secondes",
    log_jump: "Enregistrer Saut",
    jump_height: "Hauteur du Saut",
    inches: "pouces",
    personal_best: "Record Personnel",
    average_jump: "Saut Moyen",
    total_jumps: "Total Sauts",
    upload_photo: "Télécharger Photo",
    compare: "Comparer",
    timeline: "Chronologie",
    gallery: "Galerie",
    front_pose: "Pose Avant",
    side_pose: "Pose Côté",
    back_pose: "Pose Dos",
    ask_coach: "Demander au Coach",
    type_question: "Tape ta question...",
    send: "Envoyer",
    thinking: "Réflexion...",
    select_model: "Sélectionner Modèle IA",
    settings: "Paramètres",
    language: "Langue",
    notifications: "Notifications",
    dark_mode: "Mode Sombre",
    sound_effects: "Effets Sonores",
    coming_soon: "Bientôt",
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    reset: "Réinitialiser",
    undo: "Annuler",
    redo: "Rétablir",
    confirm: "Confirmer",
    close: "Fermer",
    next: "Suivant",
    previous: "Précédent",
    view_all: "Voir Tout",
    see_more: "Voir Plus",
    error: "Erreur",
    success: "Succès",
    warning: "Avertissement",
    no_data: "Aucune donnée disponible",
  },
  
  de: {
    app_name: "Pivot Performance",
    beta_banner: "BETA-MODUS — Alle Funktionen Freigeschaltet",
    beta_spots: "Plätze verfügbar",
    free_trial: "16 Tage kostenlos",
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    full_name: "Vollständiger Name",
    welcome_back: "Willkommen Zurück",
    join_beta: "Konto Erstellen",
    start_training: "Training Starten",
    dont_have_account: "Kein Konto?",
    already_have_account: "Bereits ein Konto?",
    sign_up: "Registrieren",
    sign_in: "Anmelden",
    build_your: "Baue Deinen",
    engine: "Motor",
    tagline: "Generationeller Sommer. Transformiere dein Spiel mit Konditionierung, Vertikaltraining und KI-Coaching.",
    engine_monitor: "Motor Monitor",
    engine_desc: "17-fives, Suicides, Vollfeld-Übungen",
    vertical_tracker: "Vertikal-Tracker",
    vertical_desc: "Verfolge gewonnene Zentimeter mit vertikaler Explosion.",
    ai_coaching: "KI-Coaching",
    ai_desc: "Personalisiertes Feedback",
    break_the_cycle: "Durchbreche den Zyklus",
    week_program: "Wochenprogramm",
    terms: "Allgemeine Geschäftsbedingungen",
    accept_terms: "Ich akzeptiere die AGB",
    health_warning: "Konsultiere einen Arzt vor dem Start.",
    read_terms: "AGB Lesen",
    dashboard: "Dashboard",
    schedule: "Zeitplan",
    sessions: "Sitzungen",
    badges: "Abzeichen",
    leaderboard: "Rangliste",
    program: "Programm",
    vertical: "Vertikal",
    bodyweight: "Körpergewicht",
    progress: "Fortschritt",
    library: "Bibliothek",
    coach: "KI-Coach",
    wearables: "Wearables",
    ecosystem: "Ökosystem",
    community: "Community",
    subscription: "Abonnement",
    profile: "Profil",
    share: "Partager",
    total_workouts: "Gesamte Workouts",
    this_week: "Diese Woche",
    vertical_gained: "Vertikal Gewonnen",
    current_vertical: "Aktueller Vertikal",
    quick_start: "Schnellstart",
    ready_train: "Bereit zu Trainieren?",
    your_progress: "Dein Fortschritt",
    recent_activity: "Letzte Aktivität",
    todays_workout: "Heutiges Training",
    week: "Woche",
    day: "Tag",
    phase: "Phase",
    complete: "Abschließen",
    active: "Aktiv",
    locked: "Gesperrt",
    unlocked: "Freigeschaltet",
    beast_mode: "Beast-Modus",
    current_streak: "Aktuelle Serie",
    days_completed: "Tage Abgeschlossen",
    total_days: "Gesamt Tage",
    start_workout: "Training Starten",
    mark_complete: "Als Erledigt Markieren",
    rest_day: "Ruhetag",
    your_rank: "Deine Platzierung",
    points: "Punkte",
    streak: "Serie",
    global_rankings: "Globale Rangliste",
    top_athletes: "Top-Athleten",
    choose_level: "Wähle Dein Level",
    basic: "Basis",
    pro: "Pro",
    elite: "Elite",
    per_month: "/Monat",
    popular: "Beliebteste",
    subscribe_now: "Jetzt Abonnieren",
    offline: "Offline",
    sync_ready: "Elemente zum Synchronisieren bereit",
    sync_now: "Jetzt Synchronisieren",
    push_ups: "Liegestütze",
    air_squats: "Kniebeugen",
    jump_rope: "Seilspringen",
    circuit: "Zirkel",
    reps: "Wdh",
    sets: "Sätze",
    duration: "Dauer",
    minutes: "Minuten",
    seconds: "Sekunden",
    log_jump: "Sprung Erfassen",
    jump_height: "Sprunghöhe",
    inches: "Zoll",
    personal_best: "Persönliche Bestleistung",
    average_jump: "Durchschnittlicher Sprung",
    total_jumps: "Gesamt Sprünge",
    upload_photo: "Foto Hochladen",
    compare: "Vergleichen",
    timeline: "Zeitachse",
    gallery: "Galerie",
    front_pose: "Frontpose",
    side_pose: "Seitenpose",
    back_pose: "Rückenpose",
    ask_coach: "Coach Fragen",
    type_question: "Schreibe deine Frage...",
    send: "Senden",
    thinking: "Denkt nach...",
    select_model: "KI-Modell Auswählen",
    settings: "Einstellungen",
    language: "Sprache",
    notifications: "Benachrichtigungen",
    dark_mode: "Dunkelmodus",
    sound_effects: "Soundeffekte",
    coming_soon: "Demnächst",
    loading: "Lädt...",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    reset: "Zurücksetzen",
    undo: "Rückgängig",
    redo: "Wiederholen",
    confirm: "Bestätigen",
    close: "Schließen",
    next: "Weiter",
    previous: "Zurück",
    view_all: "Alle Anzeigen",
    see_more: "Mehr Anzeigen",
    error: "Fehler",
    success: "Erfolg",
    warning: "Warnung",
    no_data: "Keine Daten verfügbar",
  },
  
  hi: {
    app_name: "पिवट परफॉर्मेंस",
    beta_banner: "बीटा मोड — सभी सुविधाएं अनलॉक",
    beta_spots: "स्लॉट बाकी",
    free_trial: "16 दिन फ्री ट्रायल",
    login: "लॉगिन",
    register: "रजिस्टर",
    logout: "लॉगआउट",
    email: "ईमेल",
    password: "पासवर्ड",
    full_name: "पूरा नाम",
    welcome_back: "वापसी पर स्वागत",
    join_beta: "खाता बनाएं",
    start_training: "ट्रेनिंग शुरू करें",
    dont_have_account: "अकाउंट नहीं है?",
    already_have_account: "पहले से अकाउंट है?",
    sign_up: "साइन अप",
    sign_in: "साइन इन",
    build_your: "बनाओ अपना",
    engine: "इंजन",
    tagline: "जेनरेशनल समर। कंडीशनिंग, वर्टिकल ट्रेनिंग और AI कोचिंग के साथ अपने गेम को ट्रांसफॉर्म करें।",
    engine_monitor: "इंजन मॉनिटर",
    engine_desc: "17-fives, सुसाइड्स, फुल-कोर्ट ड्रिल्स",
    vertical_tracker: "वर्टिकल ट्रैकर",
    vertical_desc: "वर्टिकल एक्सप्लोजन के साथ गेन्ड इंच ट्रैक करें।",
    ai_coaching: "AI कोचिंग",
    ai_desc: "पर्सनलाइज्ड फीडबैक",
    break_the_cycle: "साइकिल तोड़ो",
    week_program: "हफ्ते का प्रोग्राम",
    terms: "नियम और शर्तें",
    accept_terms: "मैं नियम और शर्तें स्वीकार करता/करती हूं",
    health_warning: "शुरू करने से पहले डॉक्टर से सलाह लें।",
    read_terms: "नियम पढ़ें",
    dashboard: "डैशबोर्ड",
    schedule: "शेड्यूल",
    sessions: "सेशन्स",
    badges: "बैज",
    leaderboard: "लीडरबोर्ड",
    program: "प्रोग्राम",
    vertical: "वर्टिकल",
    bodyweight: "बॉडीवेट",
    progress: "प्रोग्रेस",
    library: "लाइब्रेरी",
    coach: "AI कोच",
    wearables: "वियरेबल्स",
    ecosystem: "इकोसिस्टम",
    community: "कम्युनिटी",
    subscription: "सब्सक्रिप्शन",
    profile: "प्रोफाइल",
    share: "शेयर",
    total_workouts: "कुल वर्कआउट",
    this_week: "इस हफ्ते",
    vertical_gained: "वर्टिकल गेन",
    current_vertical: "करंट वर्टिकल",
    quick_start: "क्विक स्टार्ट",
    ready_train: "ट्रेन करने के लिए तैयार?",
    your_progress: "आपकी प्रोग्रेस",
    recent_activity: "हाल की एक्टिविटी",
    todays_workout: "आज का वर्कआउट",
    week: "हफ्ता",
    day: "दिन",
    phase: "फेज",
    complete: "पूरा करें",
    active: "एक्टिव",
    locked: "लॉक्ड",
    unlocked: "अनलॉक्ड",
    beast_mode: "बीस्ट मोड",
    current_streak: "करंट स्ट्रीक",
    days_completed: "दिन पूरे",
    total_days: "कुल दिन",
    start_workout: "वर्कआउट शुरू करें",
    mark_complete: "पूरा मार्क करें",
    rest_day: "रेस्ट डे",
    your_rank: "आपकी रैंकिंग",
    points: "पॉइंट्स",
    streak: "स्ट्रीक",
    global_rankings: "ग्लोबल रैंकिंग",
    top_athletes: "टॉप एथलीट्स",
    choose_level: "अपना लेवल चुनें",
    basic: "बेसिक",
    pro: "प्रो",
    elite: "एलीट",
    per_month: "/महीना",
    popular: "सबसे लोकप्रिय",
    subscribe_now: "अभी सब्सक्राइब करें",
    offline: "ऑफलाइन",
    sync_ready: "आइटम सिंक के लिए तैयार",
    sync_now: "अभी सिंक करें",
    push_ups: "पुश-अप्स",
    air_squats: "एयर स्क्वाट्स",
    jump_rope: "रस्सी कूदना",
    circuit: "सर्किट",
    reps: "रेप्स",
    sets: "सेट्स",
    duration: "अवधि",
    minutes: "मिनट",
    seconds: "सेकंड",
    log_jump: "जंप लॉग करें",
    jump_height: "जंप हाइट",
    inches: "इंच",
    personal_best: "पर्सनल बेस्ट",
    average_jump: "एवरेज जंप",
    total_jumps: "कुल जंप्स",
    upload_photo: "फोटो अपलोड करें",
    compare: "तुलना करें",
    timeline: "टाइमलाइन",
    gallery: "गैलरी",
    front_pose: "फ्रंट पोज़",
    side_pose: "साइड पोज़",
    back_pose: "बैक पोज़",
    ask_coach: "कोच से पूछें",
    type_question: "अपना सवाल लिखें...",
    send: "भेजें",
    thinking: "सोच रहा है...",
    select_model: "AI मॉडल चुनें",
    settings: "सेटिंग्स",
    language: "भाषा",
    notifications: "नोटिफिकेशन",
    dark_mode: "डार्क मोड",
    sound_effects: "साउंड इफेक्ट्स",
    coming_soon: "जल्द आ रहा है",
    loading: "लोड हो रहा है...",
    save: "सेव करें",
    cancel: "रद्द करें",
    delete: "डिलीट करें",
    reset: "रीसेट",
    undo: "अनडू",
    redo: "रीडू",
    confirm: "कन्फर्म",
    close: "बंद करें",
    next: "अगला",
    previous: "पिछला",
    view_all: "सभी देखें",
    see_more: "और देखें",
    error: "एरर",
    success: "सफल",
    warning: "चेतावनी",
    no_data: "कोई डेटा उपलब्ध नहीं",
  },
  
  ar: {
    app_name: "بيفوت برفورمنس",
    beta_banner: "وضع تجريبي — جميع الميزات مفتوحة",
    beta_spots: "أماكن متبقية",
    free_trial: "16 يوم تجربة مجانية",
    login: "تسجيل الدخول",
    register: "التسجيل",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    full_name: "الاسم الكامل",
    welcome_back: "مرحباً بعودتك",
    join_beta: "إنشاء حساب",
    start_training: "ابدأ التدريب",
    dont_have_account: "ليس لديك حساب؟",
    already_have_account: "لديك حساب بالفعل؟",
    sign_up: "إنشاء حساب",
    sign_in: "دخول",
    build_your: "ابنِ",
    engine: "محركك",
    tagline: "صيف جيلي. حوّل لعبتك مع التكييف والتدريب العمودي والتدريب بالذكاء الاصطناعي.",
    engine_monitor: "مراقب المحرك",
    engine_desc: "تمارين 17-fives، انتحارية، تمارين الملعب الكامل",
    vertical_tracker: "متتبع القفز",
    vertical_desc: "تتبع البوصات المكتسبة مع الانفجار العمودي.",
    ai_coaching: "تدريب ذكاء اصطناعي",
    ai_desc: "ملاحظات مخصصة",
    break_the_cycle: "اكسر الدورة",
    week_program: "برنامج أسبوعي",
    terms: "الشروط والأحكام",
    accept_terms: "أوافق على الشروط والأحكام",
    health_warning: "استشر طبيبًا قبل البدء.",
    read_terms: "اقرأ الشروط",
    dashboard: "لوحة التحكم",
    schedule: "الجدول",
    sessions: "الجلسات",
    badges: "الشارات",
    leaderboard: "المتصدرين",
    program: "البرنامج",
    vertical: "عمودي",
    bodyweight: "وزن الجسم",
    progress: "التقدم",
    library: "المكتبة",
    coach: "مدرب ذكاء اصطناعي",
    wearables: "الأجهزة القابلة للارتداء",
    ecosystem: "النظام البيئي",
    community: "المجتمع",
    subscription: "الاشتراك",
    profile: "الملف الشخصي",
    share: "مشاركة",
    total_workouts: "إجمالي التمارين",
    this_week: "هذا الأسبوع",
    vertical_gained: "القفز المكتسب",
    current_vertical: "القفز الحالي",
    quick_start: "بداية سريعة",
    ready_train: "مستعد للتدريب؟",
    your_progress: "تقدمك",
    recent_activity: "النشاط الأخير",
    todays_workout: "تمرين اليوم",
    week: "أسبوع",
    day: "يوم",
    phase: "مرحلة",
    complete: "إكمال",
    active: "نشط",
    locked: "مغلق",
    unlocked: "مفتوح",
    beast_mode: "وضع الوحش",
    current_streak: "السلسلة الحالية",
    days_completed: "الأيام المكتملة",
    total_days: "إجمالي الأيام",
    start_workout: "ابدأ التمرين",
    mark_complete: "وضع علامة مكتمل",
    rest_day: "يوم راحة",
    your_rank: "ترتيبك",
    points: "نقاط",
    streak: "سلسلة",
    global_rankings: "التصنيف العالمي",
    top_athletes: "أفضل الرياضيين",
    choose_level: "اختر مستواك",
    basic: "أساسي",
    pro: "محترف",
    elite: "نخبة",
    per_month: "/شهر",
    popular: "الأكثر شعبية",
    subscribe_now: "اشترك الآن",
    offline: "غير متصل",
    sync_ready: "عناصر جاهزة للمزامنة",
    sync_now: "زامن الآن",
    push_ups: "تمارين الضغط",
    air_squats: "القرفصاء",
    jump_rope: "القفز بالحبل",
    circuit: "دائرة",
    reps: "تكرارات",
    sets: "مجموعات",
    duration: "المدة",
    minutes: "دقائق",
    seconds: "ثواني",
    log_jump: "سجل القفزة",
    jump_height: "ارتفاع القفز",
    inches: "بوصات",
    personal_best: "أفضل شخصي",
    average_jump: "متوسط القفز",
    total_jumps: "إجمالي القفزات",
    upload_photo: "رفع صورة",
    compare: "مقارنة",
    timeline: "الجدول الزمني",
    gallery: "المعرض",
    front_pose: "وضعية أمامية",
    side_pose: "وضعية جانبية",
    back_pose: "وضعية خلفية",
    ask_coach: "اسأل المدرب",
    type_question: "اكتب سؤالك...",
    send: "إرسال",
    thinking: "يفكر...",
    select_model: "اختر نموذج الذكاء الاصطناعي",
    settings: "الإعدادات",
    language: "اللغة",
    notifications: "الإشعارات",
    dark_mode: "الوضع المظلم",
    sound_effects: "المؤثرات الصوتية",
    coming_soon: "قريباً",
    loading: "جاري التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    reset: "إعادة تعيين",
    undo: "تراجع",
    redo: "إعادة",
    confirm: "تأكيد",
    close: "إغلاق",
    next: "التالي",
    previous: "السابق",
    view_all: "عرض الكل",
    see_more: "المزيد",
    error: "خطأ",
    success: "نجاح",
    warning: "تحذير",
    no_data: "لا توجد بيانات",
  },
  
  zh: {
    app_name: "Pivot Performance",
    beta_banner: "测试版 — 全部功能解锁",
    beta_spots: "剩余名额",
    free_trial: "16天免费试用",
    login: "登录",
    register: "注册",
    logout: "退出",
    email: "邮箱",
    password: "密码",
    full_name: "姓名",
    welcome_back: "欢迎回来",
    join_beta: "创建账户",
    start_training: "开始训练",
    dont_have_account: "没有账户?",
    already_have_account: "已有账户?",
    sign_up: "注册",
    sign_in: "登录",
    build_your: "打造你的",
    engine: "引擎",
    tagline: "改变一切的夏天。通过体能训练、垂直跳跃训练和AI教练提升你的比赛水平。",
    engine_monitor: "引擎监控",
    engine_desc: "17-fives、自杀跑、全场训练",
    vertical_tracker: "垂直追踪",
    vertical_desc: "追踪垂直爆发力增长的每一英寸。",
    ai_coaching: "AI教练",
    ai_desc: "个性化反馈",
    break_the_cycle: "打破循环",
    week_program: "周计划",
    terms: "条款和条件",
    accept_terms: "我接受条款和条件",
    health_warning: "开始前请咨询医生。",
    read_terms: "阅读条款",
    dashboard: "仪表板",
    schedule: "日程",
    sessions: "训练课",
    badges: "徽章",
    leaderboard: "排行榜",
    program: "计划",
    vertical: "垂直",
    bodyweight: "自重训练",
    progress: "进度",
    library: "资料库",
    coach: "AI教练",
    wearables: "可穿戴设备",
    ecosystem: "生态系统",
    community: "社区",
    subscription: "订阅",
    profile: "个人资料",
    share: "分享",
    total_workouts: "总训练次数",
    this_week: "本周",
    vertical_gained: "垂直增长",
    current_vertical: "当前垂直",
    quick_start: "快速开始",
    ready_train: "准备好训练了吗?",
    your_progress: "你的进度",
    recent_activity: "最近活动",
    todays_workout: "今日训练",
    week: "周",
    day: "天",
    phase: "阶段",
    complete: "完成",
    active: "进行中",
    locked: "锁定",
    unlocked: "解锁",
    beast_mode: "野兽模式",
    current_streak: "当前连续",
    days_completed: "已完成天数",
    total_days: "总天数",
    start_workout: "开始训练",
    mark_complete: "标记完成",
    rest_day: "休息日",
    your_rank: "你的排名",
    points: "积分",
    streak: "连续",
    global_rankings: "全球排名",
    top_athletes: "顶级运动员",
    choose_level: "选择等级",
    basic: "基础",
    pro: "专业",
    elite: "精英",
    per_month: "/月",
    popular: "最受欢迎",
    subscribe_now: "立即订阅",
    offline: "离线",
    sync_ready: "项目准备同步",
    sync_now: "立即同步",
    push_ups: "俯卧撑",
    air_squats: "空气深蹲",
    jump_rope: "跳绳",
    circuit: "循环",
    reps: "次数",
    sets: "组数",
    duration: "时长",
    minutes: "分钟",
    seconds: "秒",
    log_jump: "记录跳跃",
    jump_height: "跳跃高度",
    inches: "英寸",
    personal_best: "个人最佳",
    average_jump: "平均跳跃",
    total_jumps: "总跳跃次数",
    upload_photo: "上传照片",
    compare: "对比",
    timeline: "时间线",
    gallery: "相册",
    front_pose: "正面",
    side_pose: "侧面",
    back_pose: "背面",
    ask_coach: "问教练",
    type_question: "输入你的问题...",
    send: "发送",
    thinking: "思考中...",
    select_model: "选择AI模型",
    settings: "设置",
    language: "语言",
    notifications: "通知",
    dark_mode: "深色模式",
    sound_effects: "音效",
    coming_soon: "即将推出",
    loading: "加载中...",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    reset: "重置",
    undo: "撤销",
    redo: "重做",
    confirm: "确认",
    close: "关闭",
    next: "下一步",
    previous: "上一步",
    view_all: "查看全部",
    see_more: "查看更多",
    error: "错误",
    success: "成功",
    warning: "警告",
    no_data: "暂无数据",
  },
  
  pt: {
    app_name: "Pivot Performance",
    beta_banner: "MODO BETA — Todas as Funcionalidades Desbloqueadas",
    beta_spots: "vagas restantes",
    free_trial: "16 dias grátis",
    login: "Entrar",
    register: "Cadastrar",
    logout: "Sair",
    email: "E-mail",
    password: "Senha",
    full_name: "Nome Completo",
    welcome_back: "Bem-vindo de Volta",
    join_beta: "Criar Conta",
    start_training: "Começar Treino",
    dont_have_account: "Não tem conta?",
    already_have_account: "Já tem conta?",
    sign_up: "Cadastrar",
    sign_in: "Entrar",
    build_your: "Construa Seu",
    engine: "Motor",
    tagline: "Verão geracional. Transforme seu jogo com condicionamento, treino vertical e coaching com IA.",
    engine_monitor: "Monitor do Motor",
    engine_desc: "17-fives, suicidas, exercícios de quadra completa",
    vertical_tracker: "Rastreador Vertical",
    vertical_desc: "Rastreie os centímetros ganhos com explosão vertical.",
    ai_coaching: "Coaching IA",
    ai_desc: "Feedback personalizado",
    break_the_cycle: "Quebre o Ciclo",
    week_program: "Programa Semanal",
    terms: "Termos e Condições",
    accept_terms: "Aceito os termos e condições",
    health_warning: "Consulte um médico antes de começar.",
    read_terms: "Ler Termos",
    dashboard: "Painel",
    schedule: "Agenda",
    sessions: "Sessões",
    badges: "Distintivos",
    leaderboard: "Classificação",
    program: "Programa",
    vertical: "Vertical",
    bodyweight: "Peso Corporal",
    progress: "Progresso",
    library: "Biblioteca",
    coach: "Coach IA",
    wearables: "Wearables",
    ecosystem: "Ecossistema",
    community: "Comunidade",
    subscription: "Assinatura",
    profile: "Perfil",
    share: "Compartir",
    total_workouts: "Total de Treinos",
    this_week: "Esta Semana",
    vertical_gained: "Vertical Ganho",
    current_vertical: "Vertical Atual",
    quick_start: "Início Rápido",
    ready_train: "Pronto para Treinar?",
    your_progress: "Seu Progresso",
    recent_activity: "Atividade Recente",
    todays_workout: "Treino de Hoje",
    week: "Semana",
    day: "Dia",
    phase: "Fase",
    complete: "Completar",
    active: "Ativo",
    locked: "Bloqueado",
    unlocked: "Desbloqueado",
    beast_mode: "Modo Fera",
    current_streak: "Sequência Atual",
    days_completed: "Dias Completos",
    total_days: "Total de Dias",
    start_workout: "Iniciar Treino",
    mark_complete: "Marcar Completo",
    rest_day: "Dia de Descanso",
    your_rank: "Sua Classificação",
    points: "Pontos",
    streak: "Sequência",
    global_rankings: "Rankings Globais",
    top_athletes: "Melhores Atletas",
    choose_level: "Escolha Seu Nível",
    basic: "Básico",
    pro: "Pro",
    elite: "Elite",
    per_month: "/mês",
    popular: "Mais Popular",
    subscribe_now: "Assinar Agora",
    offline: "Sem Conexão",
    sync_ready: "itens prontos para sincronizar",
    sync_now: "Sincronizar Agora",
    push_ups: "Flexões",
    air_squats: "Agachamentos",
    jump_rope: "Pular Corda",
    circuit: "Circuito",
    reps: "Reps",
    sets: "Séries",
    duration: "Duração",
    minutes: "minutos",
    seconds: "segundos",
    log_jump: "Registrar Salto",
    jump_height: "Altura do Salto",
    inches: "polegadas",
    personal_best: "Recorde Pessoal",
    average_jump: "Salto Médio",
    total_jumps: "Total de Saltos",
    upload_photo: "Enviar Foto",
    compare: "Comparar",
    timeline: "Linha do Tempo",
    gallery: "Galeria",
    front_pose: "Pose Frontal",
    side_pose: "Pose Lateral",
    back_pose: "Pose Traseira",
    ask_coach: "Pergunte ao Coach",
    type_question: "Digite sua pergunta...",
    send: "Enviar",
    thinking: "Pensando...",
    select_model: "Selecionar Modelo IA",
    settings: "Configurações",
    language: "Idioma",
    notifications: "Notificações",
    dark_mode: "Modo Escuro",
    sound_effects: "Efeitos Sonoros",
    coming_soon: "Em Breve",
    loading: "Carregando...",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    reset: "Resetar",
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    close: "Fechar",
    next: "Próximo",
    previous: "Anterior",
    view_all: "Ver Tudo",
    see_more: "Ver Mais",
    error: "Erro",
    success: "Sucesso",
    warning: "Aviso",
    no_data: "Sem dados disponíveis",
  },
  
  ko: {
    app_name: "피벗 퍼포먼스",
    beta_banner: "베타 모드 — 모든 기능 잠금 해제",
    beta_spots: "남은 자리",
    free_trial: "16일 무료 체험",
    login: "로그인",
    register: "회원가입",
    logout: "로그아웃",
    email: "이메일",
    password: "비밀번호",
    full_name: "이름",
    welcome_back: "다시 오신 것을 환영합니다",
    join_beta: "계정 만들기",
    start_training: "훈련 시작",
    dont_have_account: "계정이 없으신가요?",
    already_have_account: "이미 계정이 있으신가요?",
    sign_up: "가입하기",
    sign_in: "로그인",
    build_your: "당신의",
    engine: "엔진을 만들어라",
    tagline: "세대를 바꾸는 여름. 컨디셔닝, 수직 점프 훈련, AI 코칭으로 게임을 변화시키세요.",
    engine_monitor: "엔진 모니터",
    engine_desc: "17-fives, 자살훈련, 풀코트 드릴",
    vertical_tracker: "수직 트래커",
    vertical_desc: "수직 폭발력으로 얻은 인치를 추적하세요.",
    ai_coaching: "AI 코칭",
    ai_desc: "맞춤형 피드백",
    break_the_cycle: "사이클을 깨라",
    week_program: "주간 프로그램",
    terms: "이용약관",
    accept_terms: "이용약관에 동의합니다",
    health_warning: "시작하기 전에 의사와 상담하세요.",
    read_terms: "약관 읽기",
    dashboard: "대시보드",
    schedule: "일정",
    sessions: "세션",
    badges: "배지",
    leaderboard: "리더보드",
    program: "프로그램",
    vertical: "수직",
    bodyweight: "맨몸운동",
    progress: "진행상황",
    library: "라이브러리",
    coach: "AI 코치",
    wearables: "웨어러블",
    ecosystem: "생태계",
    community: "커뮤니티",
    subscription: "구독",
    profile: "프로필",
    share: "공유",
    total_workouts: "총 운동",
    this_week: "이번 주",
    vertical_gained: "수직 증가",
    current_vertical: "현재 수직",
    quick_start: "빠른 시작",
    ready_train: "훈련 준비됐나요?",
    your_progress: "당신의 진행상황",
    recent_activity: "최근 활동",
    todays_workout: "오늘의 운동",
    week: "주",
    day: "일",
    phase: "단계",
    complete: "완료",
    active: "활성",
    locked: "잠김",
    unlocked: "잠금 해제",
    beast_mode: "비스트 모드",
    current_streak: "현재 연속",
    days_completed: "완료 일수",
    total_days: "총 일수",
    start_workout: "운동 시작",
    mark_complete: "완료 표시",
    rest_day: "휴식일",
    your_rank: "당신의 순위",
    points: "포인트",
    streak: "연속",
    global_rankings: "글로벌 랭킹",
    top_athletes: "톱 선수",
    choose_level: "레벨 선택",
    basic: "기본",
    pro: "프로",
    elite: "엘리트",
    per_month: "/월",
    popular: "인기",
    subscribe_now: "지금 구독",
    offline: "오프라인",
    sync_ready: "동기화 준비된 항목",
    sync_now: "지금 동기화",
    push_ups: "푸시업",
    air_squats: "에어 스쿼트",
    jump_rope: "줄넘기",
    circuit: "서킷",
    reps: "회",
    sets: "세트",
    duration: "시간",
    minutes: "분",
    seconds: "초",
    log_jump: "점프 기록",
    jump_height: "점프 높이",
    inches: "인치",
    personal_best: "개인 최고",
    average_jump: "평균 점프",
    total_jumps: "총 점프",
    upload_photo: "사진 업로드",
    compare: "비교",
    timeline: "타임라인",
    gallery: "갤러리",
    front_pose: "정면 포즈",
    side_pose: "측면 포즈",
    back_pose: "후면 포즈",
    ask_coach: "코치에게 질문",
    type_question: "질문을 입력하세요...",
    send: "보내기",
    thinking: "생각 중...",
    select_model: "AI 모델 선택",
    settings: "설정",
    language: "언어",
    notifications: "알림",
    dark_mode: "다크 모드",
    sound_effects: "효과음",
    coming_soon: "출시 예정",
    loading: "로딩 중...",
    save: "저장",
    cancel: "취소",
    delete: "삭제",
    reset: "리셋",
    undo: "실행 취소",
    redo: "다시 실행",
    confirm: "확인",
    close: "닫기",
    next: "다음",
    previous: "이전",
    view_all: "모두 보기",
    see_more: "더 보기",
    error: "오류",
    success: "성공",
    warning: "경고",
    no_data: "데이터 없음",
  },
  
  ja: {
    app_name: "ピボットパフォーマンス",
    beta_banner: "ベータモード — 全機能解放",
    beta_spots: "残り枠",
    free_trial: "16日間無料",
    login: "ログイン",
    register: "登録",
    logout: "ログアウト",
    email: "メールアドレス",
    password: "パスワード",
    full_name: "氏名",
    welcome_back: "おかえりなさい",
    join_beta: "アカウント作成",
    start_training: "トレーニング開始",
    dont_have_account: "アカウントをお持ちでない?",
    already_have_account: "すでにアカウントをお持ち?",
    sign_up: "サインアップ",
    sign_in: "サインイン",
    build_your: "君の",
    engine: "エンジンを作れ",
    tagline: "世代を超える夏。コンディショニング、垂直跳びトレーニング、AIコーチングでゲームを変革。",
    engine_monitor: "エンジンモニター",
    engine_desc: "17-fives、スーサイド、フルコートドリル",
    vertical_tracker: "垂直トラッカー",
    vertical_desc: "垂直爆発力で得たインチを追跡。",
    ai_coaching: "AIコーチング",
    ai_desc: "パーソナライズされたフィードバック",
    break_the_cycle: "サイクルを破れ",
    week_program: "週間プログラム",
    terms: "利用規約",
    accept_terms: "利用規約に同意します",
    health_warning: "開始前に医師に相談してください。",
    read_terms: "規約を読む",
    dashboard: "ダッシュボード",
    schedule: "スケジュール",
    sessions: "セッション",
    badges: "バッジ",
    leaderboard: "リーダーボード",
    program: "プログラム",
    vertical: "垂直",
    bodyweight: "自重トレーニング",
    progress: "進捗",
    library: "ライブラリ",
    coach: "AIコーチ",
    wearables: "ウェアラブル",
    ecosystem: "エコシステム",
    community: "コミュニティ",
    subscription: "サブスクリプション",
    profile: "プロフィール",
    share: "シェア",
    total_workouts: "総ワークアウト",
    this_week: "今週",
    vertical_gained: "垂直ゲイン",
    current_vertical: "現在の垂直",
    quick_start: "クイックスタート",
    ready_train: "トレーニングの準備は?",
    your_progress: "あなたの進捗",
    recent_activity: "最近の活動",
    todays_workout: "今日のワークアウト",
    week: "週",
    day: "日",
    phase: "フェーズ",
    complete: "完了",
    active: "アクティブ",
    locked: "ロック",
    unlocked: "アンロック",
    beast_mode: "ビーストモード",
    current_streak: "現在の連続",
    days_completed: "完了日数",
    total_days: "総日数",
    start_workout: "ワークアウト開始",
    mark_complete: "完了をマーク",
    rest_day: "休息日",
    your_rank: "あなたのランク",
    points: "ポイント",
    streak: "連続",
    global_rankings: "グローバルランキング",
    top_athletes: "トップアスリート",
    choose_level: "レベルを選択",
    basic: "ベーシック",
    pro: "プロ",
    elite: "エリート",
    per_month: "/月",
    popular: "人気",
    subscribe_now: "今すぐ登録",
    offline: "オフライン",
    sync_ready: "同期準備完了のアイテム",
    sync_now: "今すぐ同期",
    push_ups: "プッシュアップ",
    air_squats: "エアスクワット",
    jump_rope: "縄跳び",
    circuit: "サーキット",
    reps: "回",
    sets: "セット",
    duration: "時間",
    minutes: "分",
    seconds: "秒",
    log_jump: "ジャンプを記録",
    jump_height: "ジャンプ高さ",
    inches: "インチ",
    personal_best: "自己ベスト",
    average_jump: "平均ジャンプ",
    total_jumps: "総ジャンプ数",
    upload_photo: "写真をアップロード",
    compare: "比較",
    timeline: "タイムライン",
    gallery: "ギャラリー",
    front_pose: "フロントポーズ",
    side_pose: "サイドポーズ",
    back_pose: "バックポーズ",
    ask_coach: "コーチに質問",
    type_question: "質問を入力...",
    send: "送信",
    thinking: "考え中...",
    select_model: "AIモデルを選択",
    settings: "設定",
    language: "言語",
    notifications: "通知",
    dark_mode: "ダークモード",
    sound_effects: "効果音",
    coming_soon: "近日公開",
    loading: "読み込み中...",
    save: "保存",
    cancel: "キャンセル",
    delete: "削除",
    reset: "リセット",
    undo: "元に戻す",
    redo: "やり直し",
    confirm: "確認",
    close: "閉じる",
    next: "次へ",
    previous: "前へ",
    view_all: "すべて表示",
    see_more: "もっと見る",
    error: "エラー",
    success: "成功",
    warning: "警告",
    no_data: "データなし",
  },
  
  tl: {
    app_name: "Pivot Performance",
    beta_banner: "BETA MODE — Lahat ng Features Naka-unlock",
    beta_spots: "natitirang slots",
    free_trial: "16 araw na libreng trial",
    login: "Mag-login",
    register: "Mag-register",
    logout: "Mag-logout",
    email: "Email",
    password: "Password",
    full_name: "Buong Pangalan",
    welcome_back: "Welcome Back",
    join_beta: "Gumawa ng Account",
    start_training: "Simulan ang Training",
    dont_have_account: "Wala pang account?",
    already_have_account: "May account na?",
    sign_up: "Mag-sign Up",
    sign_in: "Mag-sign In",
    build_your: "Buuin Mo Ang Iyong",
    engine: "Engine",
    tagline: "Summer na magbabago ng buhay. I-transform ang iyong laro gamit ang conditioning, vertical training, at AI coaching.",
    engine_monitor: "Engine Monitor",
    engine_desc: "17-fives, suicides, full-court drills",
    vertical_tracker: "Vertical Tracker",
    vertical_desc: "I-track ang mga inches na nakuha sa vertical explosion.",
    ai_coaching: "AI Coaching",
    ai_desc: "Personalized na feedback",
    break_the_cycle: "Basagin ang Cycle",
    week_program: "Weekly Program",
    terms: "Terms and Conditions",
    accept_terms: "Tinatanggap ko ang terms and conditions",
    health_warning: "Kumonsulta sa doktor bago magsimula.",
    read_terms: "Basahin ang Terms",
    dashboard: "Dashboard",
    schedule: "Schedule",
    sessions: "Mga Session",
    badges: "Mga Badge",
    leaderboard: "Leaderboard",
    program: "Program",
    vertical: "Vertical",
    bodyweight: "Bodyweight",
    progress: "Progress",
    library: "Library",
    coach: "AI Coach",
    wearables: "Wearables",
    ecosystem: "Ecosystem",
    community: "Community",
    teams: "Teams",
    recovery: "Recovery",
    admin: "Admin",
    subscription: "Subscription",
    share: "Share",
    analytics: "Analytics",
    profile: "Profile",
    share: "Share",
    analytics: "Analytics",
    total_workouts: "Kabuuang Workouts",
    this_week: "Ngayong Linggo",
    vertical_gained: "Vertical Gained",
    current_vertical: "Kasalukuyang Vertical",
    quick_start: "Quick Start",
    ready_train: "Handa Ka Na Bang Mag-train?",
    your_progress: "Ang Iyong Progress",
    recent_activity: "Kamakailang Activity",
    todays_workout: "Workout Ngayon",
    week: "Linggo",
    day: "Araw",
    phase: "Phase",
    complete: "Kumpletuhin",
    active: "Aktibo",
    locked: "Naka-lock",
    unlocked: "Naka-unlock",
    beast_mode: "Beast Mode",
    current_streak: "Kasalukuyang Streak",
    days_completed: "Mga Araw na Nakumpleto",
    total_days: "Kabuuang Araw",
    start_workout: "Simulan ang Workout",
    mark_complete: "Markahan Bilang Tapos",
    rest_day: "Rest Day",
    your_rank: "Ang Iyong Ranking",
    points: "Points",
    streak: "Streak",
    global_rankings: "Global Rankings",
    top_athletes: "Mga Top na Atleta",
    choose_level: "Piliin Ang Iyong Level",
    basic: "Basic",
    pro: "Pro",
    elite: "Elite",
    per_month: "/buwan",
    popular: "Pinaka-popular",
    subscribe_now: "Mag-subscribe Ngayon",
    offline: "Offline ka",
    sync_ready: "items na handa i-sync",
    sync_now: "I-sync Ngayon",
    push_ups: "Push-Ups",
    air_squats: "Air Squats",
    jump_rope: "Jump Rope",
    circuit: "Circuit",
    reps: "Reps",
    sets: "Sets",
    duration: "Tagal",
    minutes: "minuto",
    seconds: "segundo",
    log_jump: "I-log ang Jump",
    jump_height: "Taas ng Jump",
    inches: "inches",
    personal_best: "Personal Best",
    average_jump: "Average Jump",
    total_jumps: "Kabuuang Jumps",
    upload_photo: "Mag-upload ng Photo",
    compare: "Ikumpara",
    timeline: "Timeline",
    gallery: "Gallery",
    front_pose: "Front Pose",
    side_pose: "Side Pose",
    back_pose: "Back Pose",
    ask_coach: "Magtanong sa Coach",
    type_question: "I-type ang tanong mo...",
    send: "Ipadala",
    thinking: "Nag-iisip...",
    select_model: "Pumili ng AI Model",
    settings: "Settings",
    language: "Wika",
    notifications: "Mga Notification",
    dark_mode: "Dark Mode",
    sound_effects: "Sound Effects",
    coming_soon: "Malapit Na",
    loading: "Naglo-load...",
    save: "I-save",
    cancel: "Kanselahin",
    delete: "I-delete",
    reset: "I-reset",
    undo: "I-undo",
    redo: "I-redo",
    confirm: "Kumpirmahin",
    close: "Isara",
    next: "Susunod",
    previous: "Nakaraan",
    view_all: "Tingnan Lahat",
    see_more: "Tingnan Pa",
    error: "Error",
    success: "Tagumpay",
    warning: "Babala",
    no_data: "Walang available na data",
  },
  
  ru: {
    app_name: "Pivot Performance",
    beta_banner: "БЕТА РЕЖИМ — Все функции разблокированы",
    beta_spots: "мест осталось",
    free_trial: "16 дней бесплатно",
    login: "Войти",
    register: "Регистрация",
    logout: "Выйти",
    email: "Эл. почта",
    password: "Пароль",
    full_name: "Полное имя",
    welcome_back: "С возвращением",
    join_beta: "Создать Аккаунт",
    start_training: "Начать тренировку",
    dont_have_account: "Нет аккаунта?",
    already_have_account: "Уже есть аккаунт?",
    sign_up: "Зарегистрироваться",
    sign_in: "Войти",
    build_your: "Построй свой",
    engine: "Движок",
    tagline: "Лето, которое изменит поколение. Трансформируй свою игру с кондиционированием, вертикальными тренировками и ИИ-коучингом.",
    engine_monitor: "Монитор двигателя",
    engine_desc: "17-fives, суициды, упражнения на всю площадку",
    vertical_tracker: "Трекер вертикали",
    vertical_desc: "Отслеживай прирост в дюймах с вертикальным взрывом.",
    ai_coaching: "ИИ Коучинг",
    ai_desc: "Персонализированная обратная связь",
    break_the_cycle: "Сломай цикл",
    week_program: "Недельная программа",
    terms: "Условия использования",
    accept_terms: "Я принимаю условия использования",
    health_warning: "Проконсультируйтесь с врачом перед началом.",
    read_terms: "Читать условия",
    dashboard: "Панель управления",
    schedule: "Расписание",
    sessions: "Сессии",
    badges: "Значки",
    leaderboard: "Таблица лидеров",
    program: "Программа",
    vertical: "Вертикаль",
    bodyweight: "Собственный вес",
    progress: "Прогресс",
    library: "Библиотека",
    coach: "ИИ Тренер",
    wearables: "Носимые устройства",
    ecosystem: "Экосистема",
    community: "Сообщество",
    subscription: "Подписка",
    profile: "Профиль",
    share: "Поделиться",
    total_workouts: "Всего тренировок",
    this_week: "На этой неделе",
    vertical_gained: "Прирост вертикали",
    current_vertical: "Текущая вертикаль",
    quick_start: "Быстрый старт",
    ready_train: "Готов тренироваться?",
    your_progress: "Твой прогресс",
    recent_activity: "Недавняя активность",
    todays_workout: "Сегодняшняя тренировка",
    week: "Неделя",
    day: "День",
    phase: "Фаза",
    complete: "Завершить",
    active: "Активно",
    locked: "Заблокировано",
    unlocked: "Разблокировано",
    beast_mode: "Режим зверя",
    current_streak: "Текущая серия",
    days_completed: "Дней завершено",
    total_days: "Всего дней",
    start_workout: "Начать тренировку",
    mark_complete: "Отметить выполненным",
    rest_day: "День отдыха",
    your_rank: "Твой рейтинг",
    points: "Очки",
    streak: "Серия",
    global_rankings: "Мировой рейтинг",
    top_athletes: "Лучшие атлеты",
    choose_level: "Выбери свой уровень",
    basic: "Базовый",
    pro: "Про",
    elite: "Элита",
    per_month: "/месяц",
    popular: "Самый популярный",
    subscribe_now: "Подписаться сейчас",
    offline: "Вы офлайн",
    sync_ready: "элементов готово к синхронизации",
    sync_now: "Синхронизировать",
    push_ups: "Отжимания",
    air_squats: "Воздушные приседания",
    jump_rope: "Скакалка",
    circuit: "Круговая",
    reps: "Повторы",
    sets: "Подходы",
    duration: "Длительность",
    minutes: "минут",
    seconds: "секунд",
    log_jump: "Записать прыжок",
    jump_height: "Высота прыжка",
    inches: "дюймов",
    personal_best: "Личный рекорд",
    average_jump: "Средний прыжок",
    total_jumps: "Всего прыжков",
    upload_photo: "Загрузить фото",
    compare: "Сравнить",
    timeline: "Хронология",
    gallery: "Галерея",
    front_pose: "Фронтальная поза",
    side_pose: "Боковая поза",
    back_pose: "Поза сзади",
    ask_coach: "Спросить тренера",
    type_question: "Введи свой вопрос...",
    send: "Отправить",
    thinking: "Думаю...",
    select_model: "Выбрать модель ИИ",
    settings: "Настройки",
    language: "Язык",
    notifications: "Уведомления",
    dark_mode: "Тёмный режим",
    sound_effects: "Звуковые эффекты",
    coming_soon: "Скоро",
    loading: "Загрузка...",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    reset: "Сброс",
    undo: "Отменить",
    redo: "Повторить",
    confirm: "Подтвердить",
    close: "Закрыть",
    next: "Далее",
    previous: "Назад",
    view_all: "Показать все",
    see_more: "Показать ещё",
    error: "Ошибка",
    success: "Успех",
    warning: "Предупреждение",
    no_data: "Нет данных",
  },
};

// Language metadata with native names and flags
export const LANGUAGES = [
  { code: 'en', name: 'English', native: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', native: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', native: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'German', native: 'Deutsch', flag: '🇩🇪' },
  { code: 'ru', name: 'Russian', native: 'Русский', flag: '🇷🇺' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ar', name: 'Arabic', native: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'zh', name: 'Chinese', native: '中文', flag: '🇨🇳' },
  { code: 'pt', name: 'Portuguese', native: 'Português', flag: '🇧🇷' },
  { code: 'ko', name: 'Korean', native: '한국어', flag: '🇰🇷' },
  { code: 'ja', name: 'Japanese', native: '日本語', flag: '🇯🇵' },
  { code: 'tl', name: 'Tagalog', native: 'Tagalog', flag: '🇵🇭' },
];

export default translations;
